/*
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-24 08:37:19
 */
import Mock from "mockjs"

// 所有的服务端接口在接收到请求后，均响应以下JSON格式

Mock.mock("/index.php/news-list","get",{
    code: 0,//错误码
    msg: "",//错误消息
    //data为具体的消息内容，如果code不为0，则必为null
    data: [
        {   
            id:1,
            url:  require("@/assets/img/News/newsImg.png"),
            title:'领导视察暖心怀  砺砺前行展未来',
            abstract: ` 2023年1月29日下午，潜江市市长盛文军及政府成员一行莅临东方久乐汽车电子（上海）股份有限公司潜江分公司，
            进行实地参观调研。公司董事长兼总经理高劲松、潜江分公司厂长张士良陪同市领导参观了办公区域、生产车间、厂区环境等地...`,
            release_time: '2023-01-29',
            subtitle: '--潜江市领导盛文军一行参观考察久乐电子',
            main_body_data:[
                {type:'text',center:`2023年1月29日下午，潜江市市长盛文军及政府成员一行莅临东方久乐汽车电子（上海）股份有限公司潜江分公司，进行实地参观调研。公司董事长兼总经理高劲松、
                潜江分公司厂长张士良陪同市领导参观了办公区域、生产车间、厂区环境等地。`},
                {type:'img',center:require("@/assets/img/News/newsImg.png")},
                {type:'text',center:`董事长高劲松就久乐电子厂区建设情况及公司发展规划向盛市长一行领导进行了汇报：厂区总占地面积100亩，一期项目于2021年12月投入使用；久乐电子立足企业品牌和产品优势，制订切实可行的发展战略，推动传统产业转型升级，助力新兴产业加快发展。
                随后，市领导陆续参观了公司的贴片车间、插件车间和装配车间，厂长张士良向参观领导详细介绍了生产线的整个生产操作流程、技术优势和生产力。`},
                {type:'img',center:require("@/assets/img/News/newsImg-1.png")},
                {type:'text',center:`最后，市领导对公司所取得的成绩和产生的经济效益及社会效益给与充分的肯定。盛市长表示，久乐电子能准确预判和把握市场动向，积极应变，稳产扩能，积极推进传统行业转型升级，构建良好产业发展生态，助力我市制造业高质量发展，对促进经济发展做出了突出贡献；他要求潜江领导班子稳中求进、循序渐进推动企业发展，要提升服务意识，积极解决企业在发展中遇到的困难和问题，为企业在潜江发展创造良好条件。`},
            ]

        },

        {   
            id:2,
            url: require("@/assets/img/News/newsImg2.png"),
            title:'振兴乡村经济，做强县域经济',
            abstract: ` 2023年1月30日石家庄市委书记张超超、马宇骏、李雪荣、张业等领导和新乐市委书记李明政等政府主要负责人来东方久乐汽车电子（上海）股份有限公司新乐分公司新厂区观摩考察，
            新乐分公司厂长赵一樊和新厂区负责人王志拥等人陪同参观视察...`,
            release_time: '2023-01-30',
            subtitle: '--2023年1月30日市委书记张超超来我司视察',
            main_body_data:[
                {type:'img',center:require("@/assets/img/News/newsImg2.png")},
                {type:'text',center:`2023年1月30日石家庄市委书记张超超、马宇骏、李雪荣、张业等领导和新乐市委书记李明政等政府主要负责人来东方久乐汽车电子（上海）股份有限公司新乐分公司新厂区观摩考察，
                新乐分公司厂长赵一樊和新厂区负责人王志拥等人陪同参观视察，厂长赵一樊向书记张超超一行详细介绍了公司的主要产品和合作厂家及公司的发展前景，新厂区负责人王志拥向张超超汇报了新厂区的建设情况：
                厂区占地31亩，项目投资4.1亿元，建筑面积3万平方米，工程建设进度情况：整体项目于2022年8月份开工建设，一期工程已完工于2023年7月投入使用，二期工程于2023年年底完工2024年3月份投产，基地建成后实现了上海和新乐基地合并，建成后预计年产600万套汽车电子控制单元，产值6亿元，税收2000余万元.`},
                {type:'img',center:require("@/assets/img/News/newsImg2-1.png")},
                {type:'text',center:`最后市委书记张超超对久乐电子产生的经济效益作出了高度的认可，并强调要重视中小微企业的发展，小企业也会有大作为。向领导班子指出要提高站位、认清形势，以高度紧迫感加快县域经济发展和全面推进乡村振兴。`},
                {type:'img',center:require("@/assets/img/News/newsImg2-2.png")},
                {type:'img',center:require("@/assets/img/News/newsImg2-3.png")},
                {type:'text',center:`在1月30日集中观摩结束后，全市县域经济暨乡村振兴工作推进会议在市委党校举行。市委书记张超超出席会议并讲话他强调，要全面贯彻党的二十大精神，认真落实省委十届三次全会和省“两会”部署，全力打好县域经济发展翻身仗，推进乡村振兴迈上新台阶，为建设现代化、国际化美丽省会城市提供强劲动力。`},
            ]

        },

        {   
            id:3,
            url: require("@/assets/img/News/newsImg3.png"),
            title:'2023年度研发团队团建活动',
            abstract: ` 为了感谢团队伙伴一直以来的努力付出，为了增强团队成员的互相协作及高度契合度，丰富伙伴们的工作生活，于2023年6月30日-7月1日特别安排了常熟（虞山、虞山景区、尚湖景区）两日团建旅游活动，具体情况回顾如下...`,
            release_time: '2023-07-03',
            subtitle: '--2023年6月30日公司团建',
            main_body_data:[
                {type:'text',center:`为了感谢团队伙伴一直以来的努力付出，为了增强团队成员的互相协作及高度契合度，丰富伙伴们的工作生活，于2023年6月30日-7月1日特别安排了常熟（虞山、虞山景区、尚湖景区）两日团建旅游活动，具体情况回顾如下`},
                {type:'text',center:`一、活动内容
                1、活动的总旨：
                1）不局限一个固定地点而做团建项目，年轻人要有飞扬的个性，大家要跑起来。
                2）真正的团队合作，成员之间互相信任、互相帮助、取长补短，我们的工作才会更顺利，我们的前途才更加光明。
                2、活动内容
                1)破冰分组：
                项目目标:　1：用特殊的形式在新的环境中重新认识与了解队友,打造良好的团队氛围；
                2：了解培训相关信息，做好心理准备。`},
                {type:'img',center:require("@/assets/img/News/newsImg3-1.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-2.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-3.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-4.png")},
                {type:'text',center:`2)奔跑吧·尚湖定向寻宝
                在尚湖不同的景点分布了11个任务点，每项任务考查点各不相同，完成的难易程度不同, 但都需要团队齐心协力才能成功完成。项目收获：全员参与，高度集中专注力，不断尝试，直到成功的喜悦。大家为了完成所有任务,也是蛮拼的…看图吧`},
                {type:'img',center:require("@/assets/img/News/newsImg3-5.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-6.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-7.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-8.png")},
                {type:'text',center:`队员因“教练说”游戏失败，被拉上去做惩罚——那妖娆的动作配上那句“讨厌”，让在场员工笑喷了`},
                {type:'img',center:require("@/assets/img/News/newsImg3-9.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-10.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-11.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-12.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-13.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-14.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-15.png")},
                {type:'text',center:`大家都专注于游戏中, 合力筑塔, 冠军团队合影, 定向寻宝——冠军团队产生，大家笑得合不拢嘴`},
                {type:'text',center:`3）虞山自由行
                团队自由的漫步于素有“七溪流水皆通海，十里青山半入城”美称的虞山风景区，与虞山、古城、山南尚湖融为一体，欣赏自然山水，品味人文景观。`},
                {type:'img',center:require("@/assets/img/News/newsImg3-16.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-17.png")},
                {type:'text',center:`4）入住常熟裕坤丽呈华廷酒店`},
                {type:'img',center:require("@/assets/img/News/newsImg3-18.png")},
                {type:'img',center:require("@/assets/img/News/newsImg3-19.png")},
                {type:'text',center:`一个第一次在闲暇之余聚集了这么多久乐人的地方，可以自由组团鬼哭狼嚎、可以半夜还在玩狼人杀游戏、可以随心所欲找好朋友、好同事畅聊到半夜的地方。`},
                {type:'text',center:`3.活动感受
                对于公司对此活动的精心安排，大家感受颇深，在这个团建里，每个人都是闪耀的小星星。因为我们赋予了热情，默契，更重要的是勇气和努力，创造了属于我们的闪耀时刻！`},
                {type:'text',center:`二.活动目标的达成度
                我们当初的设定，完全定格在框架里：
             团队凝聚力：公司是一个集体，只有所有员工团结一心、紧密合作，才能完成公司的使命，实现企业的目标。缓解工作压力：徒步在风景秀丽、空气清新的尚湖风景区，并进行园内寻宝，释放工作压力，开拓思维，培养团队合作精神，达到放松身心、劳逸结合的效果。
             燃烧激情：树立团队成员对团队目标的一致性，创新意识，激发团队实现目标的激情，为下面工作做铺垫。
             执行力：它是把目标变更为结果的行为，是一个结果，一种态度，也是一种习惯。它体现的是一种负责、敬业的精神，一种服从、诚实的态度。`},
             {type:'text',center:`增强员工归属感：只有感到归属，员工才能更加积极，真正地为公司的发展做出贡献。通过团队建设活动，员工间加深了解，拥有了这个大家庭的归属感，同时也真正感受到了公司的关心和支持，这很重要。
             通过此次团建活动把不同背景、不同个性、不同职场和不同经验的人组织在一起，使他们成为一个富有成效的工作团队，既丰富了娱乐生活，同时也塑造了一定的团队力量。我们学会了利用团队的气力，让每一个队员都发挥出自己的本事，通过互补打造出一个完美的团队。每当队员顺利完成挑战之后，我们的内心体会到了成功的喜欢和骄傲感。我们感受到了一个团队的凝聚力是多么的重要，汗水与泪水，痛楚与欢乐交织在一起。
             此次活动从开始立项到执行结束，都充分体现了同事之间互帮互助的团结精神，在整个活动过程，各位同事的极力配合使得整个活动能得以圆满结束，希望下次我们的团建活动举办得更加完美精彩。`},
             {type:'img',center:require("@/assets/img/News/newsImg3.png")},
            ]

        },

        {   
            id:4,
            url: require("@/assets/img/News/newsImg4.png"),
            title:'久乐电子召开2022年度股东会暨第一届董事会第12次会议',
            abstract: ` 8月16日，久乐电子在上海总部召开了2022年度股东大会暨第一届董事会第12次会议。股东代表、董事会及监事会成员出席会议，会议由久乐电子董事长兼总经理高劲松同志主持...`,
            release_time: '2023-08-16',
            subtitle: '--久乐电子在上海总部召开了2022年度股东大会',
            main_body_data:[
                {type:'text',center:`8月16日，久乐电子在上海总部召开了2022年度股东大会暨第一届董事会第12次会议。股东代表、董事会及监事会成员出席会议，会议由久乐电子董事长兼总经理高劲松同志主持。`},
                {type:'text',center:`会上，董事长兼总经理高劲松同志对各股东单位、董事、监事长期以来对久乐电子公司的大力支持表示感谢。高总分别从公司业务发展、内部管理等方面，全面总结了公司2022年度工作完成情况。会议按照议程召开，审议通过了《2022年度总经理报告》、《2022年度财务决算报告》、《2023年度财务预算报告》等相关股东会、董事会议题。公司股东对久乐电子在2022年疫情及全球芯片严重短缺的情况下，以研发替代、创新为基础，以快速生产为保障，积极推进各项工作和目标，对2022年的经营成果给予了充分肯定。`},
                {type:'text',center:`久乐电子将根据此次会议精神，认真做好股东会、董事会决议事项的贯彻落实，继续保持稳中有进，进中向好的发展态势。`},
                {type:'img',center:require("@/assets/img/News/newsImg4.png")},
                
            ]

        },


        {   
            id:5,
            url: require("@/assets/img/News/newsImg5.png"),
            title:'在关怀中砥砺前行',
            abstract: ` 2023年10月24日下午，市委书记盛文军及政府成员等一行领导莅临东方久乐汽车电子（上海）股份有限公司潜江分公司进行实地调研，公司董事长兼总经理高劲松陪同市领导参观了厂区在建项目及生产车间等...`,
            release_time: '2023-10-24',
            subtitle: '----潜江市领导盛文军一行实地调研东久电子',
            main_body_data:[
                {type:'text',center:`2023年10月24日下午，市委书记盛文军及政府成员等一行领导莅临东方久乐汽车电子（上海）股份有限公司潜江分公司进行实地调研，公司董事长兼总经理高劲松陪同市领导参观了厂区在建项目及生产车间等。`},
                {type:'img',center:require("@/assets/img/News/newsImg5.png")},
                {type:'text',center:`董事长高劲松就东久电子厂区建设情况及公司发展规划向盛书记一行领导进行了汇报：厂区总占地面积100亩，一期项目于2021年12月投入使用，2022年产值达到3.4亿元，实现税收1200万元。二期项目已完成50亩建设用地摘牌和土地平整。东久电子立足企业品牌和产品优势，制订切实可行的发展战略，推动传统产业转型升级，助力新兴产业加快发展。`},
                {type:'text',center:`盛文军书记深入生产车间，实地参观企业生产线和产品展示，总经理高劲松向参观领导详细介绍了企业生产操作流程、技术优势和生产力。盛书记鼓励企业要坚定信心，抢抓机遇，进一步拓展市场，提高产品质量和竞争力。`},
                {type:'img',center:require("@/assets/img/News/newsImg5-1.png")},
                {type:'text',center:`通过此次调研活动，盛文军书记对企业在技术创新、产品研发、市场开拓等方面所取得的成绩给予了充分肯定，并表示政府将一如既往地支持企业发展，积极帮助企业解决实际困难和问题。同时，他希望企业能够继续加强内部管理，提高产品质量和竞争力，为地方经济发展做出更大的贡献。`},
                
            ]

        },

        {   
            id:6,
            url: require("@/assets/img/News/newsImg6.png"),
            title:'河北新乐厂区开业典礼',
            abstract: ` 在这丰收的季节，我们欢聚一堂，共同见证一个历史性的时刻------东方久乐汽车电子（上海）股份有限公司新乐分公司新厂区于2023年11月9日上午举行了盛大的开业典礼仪式。`,
            release_time: '2023-11-09',
            subtitle: '----东久电子新乐新厂区开业',
            main_body_data:[
                {type:'text',center:`在这丰收的季节，我们欢聚一堂，共同见证一个历史性的时刻------东方久乐汽车电子（上海）股份有限公司新乐分公司新厂区于2023年11月9日上午举行了盛大的开业典礼仪式。莅临现场的多位领导和嘉宾与我们共同见证我们东久电子开业典礼这盛大时刻！`},
                // {type:'img',center:require("@/assets/img/News/newsImg6.png")},
                {type:'video', short_video:require("@/assets/video/新乐新厂区开业01.mp4"), leng_video:require("@/assets/video/新乐新厂区开业01.mp4"), pic: require("@/assets/img/News/newsImg6.png")},
                // {type:'text',center:`莅临现场的多位领导和嘉宾与我们共同见证我们东久电子开业典礼这盛大时刻！`},
                // {type:'img',center:require("@/assets/img/News/newsImg6-1.png")},
                {type:'text',center:`公司董事长高劲松高总致辞：新乐分公司是东久电子第一个生产基地，具备最完善的生产支持部门，具有公司最强的技术部门，为公司11年的发展做出了突出的贡献，经历了多次的考验，尤其疫情期间展现出了一支最能吃苦最能战斗的队伍，经历了11年的奋斗我们终于在新乐有了自己的生产基地，为下一步发展打下了坚实基础......，并宣布开业典礼正式开始!`},
                {type:'img',center:require("@/assets/img/News/newsImg6-2.png")},
                {type:'text',center:`新乐分公司新厂区项目项目总投资额为4亿元，占地面积3.3万平方米。新厂区将拥有先进的生产线、技术人才和经验丰富的生产人员，将为客户提供更高品质的产品和服务。`},
                {type:'text',center:`东久电子各位副总上台致辞宣誓`},
                {type:'img',center:require("@/assets/img/News/newsImg6-3.png")},
                {type:'text',center:`新乐分公司新厂区的建立，是我们公司发展历程中的一个里程碑，也是我们对于未来更美好生活的坚定信念的体现。这不仅意味着我们将有更大的生产能力，更好的工作环境，更意味着我们将以更高的标准，更优的服务，更创新的科技来服务我们的客户，回馈我们的社会。`},
                {type:'text',center:`各位部长和主管们上台致辞：`},
                {type:'img',center:require("@/assets/img/News/newsImg6-4.png")},
                {type:'text',center:`台上部长和主管们激情澎湃、斗志昂扬，趁着此刻的心情，一同宣誓：东久电子  扬帆起航,    东久电子   再创辉煌`},
                {type:'img',center:require("@/assets/img/News/newsImg6-5.png")},
                {type:'img',center:require("@/assets/img/News/newsImg6-6.png")},

                {type:'text',center:`为了感谢我们东久人的默默付出，高总特意为我们东久人发放了红包，感谢高总的认可，并激励东久人在以后得工作中更加努力奋斗!`},
                {type:'img',center:require("@/assets/img/News/newsImg6-7.png")},
                {type:'img',center:require("@/assets/img/News/newsImg6-8.png")},
                {type:'img',center:require("@/assets/img/News/newsImg6-9.png")},
                {type:'text',center:`东方久乐汽车电子（上海）股份有限公司成立11年，从一条产线到现在的17条产线，从8人到700多人，从10多万套产量到900多万套产量，离不开所有支持、参与新厂区建设的各级领导和工作人员的辛勤工作和无私奉献，同时我们要感谢我们的客户和合作伙伴们对我们持续的支持和信任，更要感谢十几载默默付出，勤恳工作的东久人，是大家的努力和坚持成就了东久电子的辉煌。`},
                {type:'text',center:`11响礼炮的鸣响，承载着我们共同的使命愿景重新远扬启航，这是我们新的起点...`},
                {type:'img',center:require("@/assets/img/News/newsImg6-10.png")},

                {type:'text',center:`新乐分公司新厂区的建成，是机遇也是挑战，我们将继续坚持务实、高效、开拓、创新的工作作风，坚持技术创新、精益管理、专注汽车电子、提升客户价值的质量方针，秉承顾客至上、信誉第一的企业宗旨，为打造国内一流国际知名的汽车电子企业而努力奋斗！`},
                {type:'img',center:require("@/assets/img/News/newsImg6-11.png")},
               
            ]

        },

        {   
            id:7,
            url: require("@/assets/img/News/newsImg7.png"),
            title:'新乐市人大常委会副主任一行到新乐分公司视察',
            abstract: ` 11月17日上午，新乐市人大常委会副主任史战英一行到东久电子所属新乐分公司视察，参观公司新厂区并听取公司项目建设工作开展情况汇报。新乐市有关人大代表及相关单位，新乐分公司行政部主管王志拥陪同视察。`,
            release_time: '2023-11-18',
            subtitle: '----新乐市人大常委会副主任史战英一行到东久电子所属新乐分公司视察',
            main_body_data:[
                {type:'text',center:`11月17日上午，新乐市人大常委会副主任史战英一行到东久电子所属新乐分公司视察，参观公司新厂区并听取公司项目建设工作开展情况汇报。新乐市有关人大代表及相关单位，新乐分公司行政部主管王志拥陪同视察。`},
                {type:'img',center:require("@/assets/img/News/newsImg7.png")},
                {type:'text',center:`史战英一行视察项目现场后，详细了解了公司发展历程、生产研发、工艺流程等情况。史战英强调，一要抢抓发展机遇，把握市场需求，及时发现有利机会，坚定不移走好高质量发展之路。二要抓紧加大生产规模，切实加大研发投入，实现生产效益最大化。三要加大市场开拓力度，深耕现有业务市场，打响自主品牌在市场上的知名度。`},
                {type:'img',center:require("@/assets/img/News/newsImg7-1.png")},
                {type:'text',center:`王志拥汇报了东久电子近年来重点工作进展情况、下一步工作思路等。他表示，东久电子下一步将加强核心技术攻关工作力度，继续做好研发、质量工艺、精益化管理等工作，借助资本市场加速推进公司发展。项目建成后将大力推进我市汽车电子核心技术发展，有利于推动本地高端装备制造产业发展，将为县域经济实现高质量发展打下坚实基础。`},
                
            ]

        },


        {   
            id:8,
            url: require("@/assets/img/News/newsImg8.png"),
            title:'雪寒人心暖 除雪暖意融',
            abstract: ` 12月14日，雪花飘然而至，新乐市普降大雪。一夜间，银装素裹，更增添了几分冬日的气息。为确保员工工作出行安全，第一时间，新厂区领导以身作则，积极号召和组织扫雪活动，我厂区员工积极响应，不畏严寒，纷纷投入到扫雪活动中，形成了这季里最美的风景线！`,
            release_time: '2023-12-15',
            subtitle: '----记新乐分公司新厂区开展员工扫雪除冰活动',
            main_body_data:[
                {type:'text',center:`12月14日，雪花飘然而至，新乐市普降大雪。一夜间，银装素裹，更增添了几分冬日的气息。为确保员工工作出行安全，第一时间，新厂区领导以身作则，积极号召和组织扫雪活动，我厂区员工积极响应，不畏严寒，纷纷投入到扫雪活动中，形成了这季里最美的风景线！`},
                {type:'img',center:require("@/assets/img/News/newsImg8.png")},
                {type:'text',center:`凛冽的寒风、零下的低温、结冰的路面，使清扫工作变的十分艰难，许多人的手和脸被冻得通红，然而，这一切丝毫没有影响大家的劳动热情，他们团结协作，井然有序，扫的扫、铲的铲，干得热火朝天。经过奋战，新厂区内外道路上的积雪被打扫得干干净净，确保了公司员工的出行安全。`},
                {type:'img',center:require("@/assets/img/News/newsImg8-1.png")},
                {type:'text',center:`大家扫去的是雪，带来的更加是东久人乐观向上、顽强拼博的奋斗精神。相信在这个充满爱心的厂区里，有奉献相伴，冬天不会冷。`},
                {type:'img',center:require("@/assets/img/News/newsImg8-2.png")}
                
            ]

        },

        
        {   
            id:9,
            url: require("@/assets/img/News/newsImg9.png"),
            title:'新乐市市委李书记赴东久电子新乐分公司现场调研',
            abstract: ` 2月27日上午，新乐市市委李书记带领市科工局、发改局、税务局、自规局等相关部门负责同志一行赴东久电子所属新乐分公司现场调研，参观公司新厂区并深入车间实地考察了解生产经营情况。分公司厂长赵一樊等相关人员陪同此次调研活动。`,
            release_time: '2024-02-28',
            subtitle: '----新乐市市委李书记赴东久电子新乐分公司现场调研',
            main_body_data:[
                {type:'text',center:`2月27日上午，新乐市市委李书记带领市科工局、发改局、税务局、自规局等相关部门负责同志一行赴东久电子所属新乐分公司现场调研，参观公司新厂区并深入车间实地考察了解生产经营情况。分公司厂长赵一樊等相关人员陪同此次调研活动。`},
                {type:'img',center:require("@/assets/img/News/newsImg9.png")},
                {type:'text',center:`李书记一行在公司生产车间实地考察参观，厂长赵一樊向一行人详细介绍汇报企业生产经营、市场销售、改革创新、安全生产、环境保护等工作，李书记听取汇报后对公司的发展给予高度评价，并就企业下一步高质量发展提出指导意见。`},
                {type:'img',center:require("@/assets/img/News/newsImg9-1.png")},
                {type:'text',center:`李书记强调，重点工业企业是市场经济发展的中流砥柱，是推动经济社会高质量发展的重要主体和抓手。希望新乐分公司在今后工作中应抢抓市场机遇，加大生产研发，扩大生产规模，提高产品质量，打造特色品牌，形成品牌效应，推动产业集群集聚发展，不断提升企业发展的质量和效益，为新乐市高质量发展提供重要支撑。`}, 
            ]

        },

        {   
            id:10,
            url: require("@/assets/img/News/newsImg10.png"),
            title:'长安汽车专家团队赴新乐分公司考察 携手共筑品质座驾基石',
            abstract: ` 12月16日，长安汽车一支由技术、质量专家组成的精英团队专程前往东久电子新乐分公司，针对座椅控制器产品展开深度考察与交流, 旨在进一步优化汽车座椅功能，提升驾乘体验，为双方深度合作筑牢根基。总公司副总经理杨超陪同考察。`,
            release_time: '2024-12-17',
            subtitle: '----新乐分公司行政部  供稿',
            main_body_data:[
                {type:'text',center:`12月16日，长安汽车一支由技术、质量专家组成的精英团队专程前往东久电子新乐分公司，针对座椅控制器产品展开深度考察与交流，旨在进一步优化汽车座椅功能，提升驾乘体验，为双方深度合作筑牢根基。总公司副总经理杨超陪同考察。`},
                {type:'img',center:require("@/assets/img/News/newsImg10.png")},
                {type:'text',center:`抵达公司后，专家团队径直深入生产一线，先后考察了样品陈列区、文化宣传区、仓储物流区、生产车间等。在座椅控制器生产区域，现代化的生产线有序运转，工人们严谨细致地操作着各类精密设备，从芯片贴片、电路焊接到外壳组装，一道道工序精准流畅。分公司负责人详细讲解每一个生产环节的工艺管控，着重展示了自动化检测设备如何精准剔除不良品，确保产品零缺陷率，长安专家们不时驻足询问，对生产流程的精细化程度给予高度肯定。`},
                {type:'img',center:require("@/assets/img/News/newsImg10-1.png")},
                {type:'text',center:`随后会上，双方围绕座椅控制器技术创新与应用、本次评估过程中发现的不足与问题及相关人员廉洁跟踪开展研讨。东久汽车电子的研发团队分享了最新研发成果，如针对座椅多向电动调节的智能算法优化，能实现更顺滑、精准的操控；还有在控制器节能减耗方面的突破，延长电池续航表现。长安汽车专家则依据市场反馈及整车适配需求，提出个性化定制建议，期望在控制器联动调节上更趋智能人性化，双方思维碰撞，挖掘诸多合作创新点。`}, 
                {type:'img',center:require("@/assets/img/News/newsImg10-2.png")},
                {type:'text',center:`长安汽车代表表示：“座椅控制器虽小，却关乎车内舒适度关键体验，东久电子展现出的专业制造实力与研发活力令人瞩目，期待以此考察为契机，深化合作，共同打造行业领先的座椅控制系统。”此次考察为双方后续紧密协作、联合攻关明晰方向，有望推动汽车座椅智能化变革迈向新征程。`}, 
            ]

        },


        {   
            id:11,
            url: require("@/assets/img/News/newsImg11.png"),
            title:'2025年度东久电子新乐分公司团建活动',
            abstract: ` 为进一步增强团队凝聚力与协作力，激发员工干事创业热情，2025年8月2日至3日，东久电子新乐分公司组织员工赴平山黄金寨景区开展为期两天的主题团建活动。在青山叠翠、溪流潺潺的自然画卷中，一场融合自然探索、趣味互动与团队协作的“能量充电之旅”温情启幕。`,
            release_time: '2025-08-08',
            subtitle: '----新乐分公司行政部  供稿',
            main_body_data:[
                {type:'text',center:`为进一步增强团队凝聚力与协作力，激发员工干事创业热情，2025年8月2日至3日，东久电子新乐分公司组织员工赴平山黄金寨景区开展为期两天的主题团建活动。在青山叠翠、溪流潺潺的自然画卷中，一场融合自然探索、趣味互动与团队协作的“能量充电之旅”温情启幕。具体情况回顾如下：
一、活动内容
1、活动的宗旨：
一个团队，只有当凝聚力和团结性深入人心，才能激发出每个人的潜力，共同迈向更高的目标。
2、活动内容
（1）山水为媒 共赴夏日狂欢----平山黄金寨自由行
迎着初升的朝阳，载满欢声笑语的大巴车抵达黄金寨景区。员工们身着轻便运动装，精神饱满地开启首日活动。上午团建目标直指景区地标——麒麟山。沿着青石阶拾级而上，沿途绿树成荫、鸟鸣清脆，同事们或并肩攀谈缓解疲惫，或驻足拍摄沿途美景，用镜头记录下“人在景中走”的惬意。尽管攀登艰辛，但“我来帮你背包”“等等后面的伙伴”的暖心互助，让登山过程成为一次“心与心靠近”的旅程。最终，全员成功登顶，俯瞰群峰连绵、云雾缭绕的壮丽景色，掌声与欢呼声响彻山间。`},
                {type:'img',center:require("@/assets/img/News/newsImg11-1.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-2.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-3.png")},
                {type:'text',center:`（2）“娱乐项目大挑战”
黄金寨景区内的激流飞渡、管式滑道、七彩滑道、玻璃吊桥四大“网红项目”成为员工们的“打卡圣地”：激流飞渡中，大家套上防水雨衣，从滑道俯冲而下，溅起的水花裹挟着尖叫与欢笑；管式滑道如“时空隧道”穿梭林间，顺势而下的失重感让人忍不住大喊“太爽了”；七彩滑道以炫目的彩色轨道和坡度设计点燃竞技热情，风驰电掣般的速度引发阵阵惊呼；玻璃吊桥悬于百米高空，俯瞰脚下深谷与溪流，有人紧张得攥紧护栏，也有人大胆摆拍“云端大片”，挑战恐惧的同时，更让团队成员在“共赴心跳”中加深了信任。`},
                {type:'img',center:require("@/assets/img/News/newsImg11-4.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-5.png")},
                {type:'text',center:`惊险刺激的玻璃吊桥`},
                {type:'img',center:require("@/assets/img/News/newsImg11-6.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-7.png")},
                {type:'text',center:`时空隧道般的管式滑道&七彩滑道`},
                {type:'img',center:require("@/assets/img/News/newsImg11-8.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-9.png")},
                {type:'text',center:`激流飞渡--- 夹杂着尖叫与欢笑`},
                {type:'text',center:`（3）篝火晚会
夜幕降临，景区露营区的篝火晚会为疲惫的身心注入温暖。烧烤架上，滋滋冒油的羊肉串、外焦里嫩的鸡翅香气四溢；篝火燃起，暖黄的光映着每张笑脸，大家手拉手围成圈，齐祝平安顺遂。卡拉OK环节更是“神仙打架”，引来阵阵喝彩。烟火气与歌声交织，平日里“各忙各的”同事，此刻成了最亲密的“家人”。`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-10.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-11.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-12.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-13.png")},
                {type:'text',center:`（4）入住民族风情园酒店`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-14.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-15.png")},
                {type:'text',center:`团建聚餐落幕，但我们的故事才刚刚开始，与团队成员共住一檐下，这份亲密无间，难以言表。`}, 
                {type:'text',center:`（5）次日破冰之旅： 
1．热身运动
目的：组织所有参与活动的人员进行热身训练，为接下来的拓展活动项目进行准备`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-16.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-17.png")},
                {type:'text',center:`放松模式--按摩操&拍打操`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-18.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-19.png")},
                {type:'text',center:`热身游戏--夺红旗`}, 
                {type:'text',center:`2．破冰组队
队员在教练带领下完成并制定队名，队歌，队训，队徽，选出队长。通过组形式，迅速建立沟通环境，初步形成团队气氛
活动目的：增强队员之间的互相认识和了解，鼓励沟通，打消彼此隔膜、拉近距离；在初步团队建设完成各项任务的过程中营造团队气氛，形成初步统一的团队！`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-20.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-21.png")},
                {type:'text',center:`共同讨论队名队训            超越队（超越极限、挑战自我）`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-22.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-23.png")},
                {type:'text',center:`星火队（星星之火、永不言败）      巅峰队（穿越巅峰、创造奇迹）`}, 
                 {type:'text',center:`（6）飞盘竞技
               
团建活动从“放松模式”切换为“协作模式”。“破冰之旅”以趣味游戏开场：随后的“飞盘竞技”成为全天焦点。
a.飞盘教学
项目目标：接触飞盘，了解飞盘，学会飞盘玩法`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-24.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-25.png")},
                {type:'text',center:`教练讲解飞盘技巧             员工紧张练习中`}, 
                {type:'text',center:`b.飞盘嘉年华
项目收获：通过飞盘团建活动，团队成员之间的关系更加密切，增强了互相的信任和合作精神，同时提高了个人的技能水平，增强了团队的凝聚力和战斗力。该活动解决了成员之间沟通不畅、协作能力不足的问题，达到了预期效果。`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-26.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-27.png")},
                {type:'text',center:`飞盘嘉年华---九宫格`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-28.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-29.png")},
                {type:'text',center:`飞盘嘉年华——飞盘掷框`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-30.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-31.png")},
                {type:'text',center:`飞盘嘉年华—— 掷准网`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-32.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-33.png")},
                {type:'text',center:`飞盘嘉年华—— 保龄球`}, 
                {type:'text',center:`绿茵场上，跑位、传盘、投掷……每一次精准传递都伴随着队友的击掌欢呼，即使失误也互相鼓励：“没关系，我们再来！”。场边啦啦队的“加油声”与“战术指导声”此起彼伏，原本陌生的同事因一颗飞盘紧密联结，“团队”二字在奔跑与协作中被深刻诠释。  `}, 
                {type:'text',center:`（7）团队留念竞技结束后全体员工和冠军团队合影留念，镜头定格的，是一张张灿烂的笑脸，更是一个团队同心同行的温暖印记。`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-34.png")},
                {type:'img',center:require("@/assets/img/News/newsImg11-35.png")},
                {type:'text',center:` 团队合影留念                   冠军团队合影--星火队`}, 
                {type:'text',center:`二、活动目标达成度

团队凝聚力：我们并肩作战，汇聚智慧与汗水，为了同一个梦想努力拼搏，此乃团队之真谛！在团建活动中，我们充分体现了团结协作的精神。无论是完成团队任务，还是解决突发问题，大家都能紧密团结在一起，共同面对挑战。这种团结协作的精神，让我深刻体会到，一个优秀的团队离不开每个人的付出和努力。
缓解工作压力：在蓝天白云下，挥洒汗水，享受运动的快乐，释放工作压力，在紧张的工作和生活中，适当的放松和减压能够有效地缓解压力和焦虑，提高工作效率和生活质量。
增强员工归属感：通过参与团建活动，员工有机会感受到企业对他们的关心和重视，从而增强他们对企业的信任和忠诚度。同时，良好的团队合作和成就感也会加深员工对企业的归属感。
此次团建活动，既是一次身心的放松，更是一场团队的“精神充电”。两天的团建向大家展示出东久电子不仅有攻坚克难的“硬核实力”，更有温暖向上的“团队底色”。工作中，我们是推动技术创新的“尖兵”；生活中，我们是彼此支撑的“家人”。未来，让我们带着这份凝聚力，以更饱满的热情投入事业，共同书写东久的新篇章，让“团结、拼搏、创新、共赢”的企业文化融入每一位员工的血液，为企业高质量发展注入更强劲的动力。`}, 
                {type:'img',center:require("@/assets/img/News/newsImg11-36.png")},
            ]

        },


        {   
            id:12,
            url: require("@/assets/img/News/newsImg12.png"),
            title:'凝心聚力踏歌行， 共赴嘉兴话担当—— 公司嘉兴南湖、 梅花洲团建二日游纪实',
            abstract: ` 当城市的喧嚣被清晨的微风轻轻拂去，公司 43 名员工怀着期待与热忱，踏上了前往嘉兴的团
建旅程。此次嘉兴南湖、梅花洲二日游，不仅是一次放松身心的出行，更是一场凝聚团队力量、深  化同事情谊的成长之旅，每一处风景、每一个瞬间，都成为了大家心中难忘的记忆。`,
            release_time: '2025-09-25',
            subtitle: '----苏州分公司行政部  供稿',
            main_body_data:[
                {type:'text',center:`当城市的喧嚣被清晨的微风轻轻拂去，公司 43 名员工怀着期待与热忱，踏上了前往嘉兴的团
建旅程。此次嘉兴南湖、梅花洲二日游，不仅是一次放松身心的出行，更是一场凝聚团队力量、深  化同事情谊的成长之旅，每一处风景、每一个瞬间，都成为了大家心中难忘的记忆。`},
                {type:'img',center:require("@/assets/img/News/newsImg12-1.png")},
                {type:'text',center:`一 、行程掠影 ：沉醉江南好风光

首日清晨 9 点，大家在公司指定地点集合，乘坐 49 座旅游大巴向着嘉兴出发。车窗外的风景
不断变换，从城市的高楼大厦逐渐过渡到江南的田园水乡，车内的欢声笑语此起彼伏，平日里因工  作忙碌而难得深入交流的同事们，此刻畅谈生活与工作的趣事，部门间的陌生感在轻松的氛围中逐  渐消散。经过约 2 小时的车程，我们抵达了此行的第一站 —— 嘉兴月河历史街区。
走进月河历史街区，仿佛瞬间穿越千年时光。这里是嘉兴市南湖区保存最完整的江南水乡历史
街区，依托京杭大运河形成了 “三河三街 ” 的独特格局，1700 余年的商贸文化遗存在此静静流   淌。青石板路蜿蜒曲折，两旁的白墙黛瓦鳞次栉比，古朴的店铺幌子随风摇曳，木质门窗上精致的  雕花历经岁月洗礼仍清晰可见。偶尔传来的评弹声从街边茶馆飘出，软糯的吴侬软语与潺潺的流水  声交织，更添几分江南韵味。同事们三三两两漫步其间，有的驻足欣赏精美的木雕窗花，指尖轻轻  触碰木质纹理，感受历史的温度；有的在特色小吃摊前排队购买嘉兴粽子，剥开翠绿的粽叶，糯米  的清香与肉粒的鲜美瞬间充斥鼻腔；还有的举起相机，将白墙黛瓦、小桥流水与同事的笑容一同定  格，让这如画的水乡景致成为永恒的记忆。阳光透过树叶的缝隙洒下，斑驳的光影落在大家脸上，  每个人的嘴角都洋溢着轻松惬意的笑容。
`},
                {type:'img',center:require("@/assets/img/News/newsImg12-3.png")},
                {type:'text',center:`次日清晨，在酒店享用过丰富的自助早餐后，我们前往此次行程的核心景点 —— 南湖。作为
浙江三大名湖之一，南湖因位于嘉兴城南而得名，原名滮湖、陆渭池、马场湖，东、西两湖形似鸳  鸯交颈，古时常有鸳鸯栖息，故又名鸳鸯湖。站在湖边远眺，湖面开阔澄澈，宛如一块镶嵌在江南  大地上的碧玉，微风拂过，湖水泛起阵阵涟漪，阳光洒在水面上，波光粼粼，耀眼夺目。我们有序  登上游船，随着游船缓缓驶离岸边，湖心岛的轮廓逐渐清晰，岛上的烟雨楼古朴典雅，朱红的门
窗、飞翘的屋檐在绿树掩映下更显庄重秀丽，尽显江南水乡的温婉气质。导游站在船头，手持扩音  喇叭，向我们细致讲述着南湖的历史，从古代文人墨客在此留下的诗词佳作，到近代中国共产党第  一次全国代表大会在南湖红船召开的光辉历程。当听到 “红船从这里起航，中国革命的火种从这里 点燃 ” 时，大家纷纷驻足船头，凝视着湖面，仿佛能看到百年前革命先辈们在红船上运筹帷幄的场 景，心中的敬意与使命感油然而生。同事们一边认真聆听历史，一边欣赏着湖光山色，不时相互交  流感悟，让红色文化的种子在心中悄然扎根。
`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-6.png")},
                {type:'text',center:`二、温馨时刻 ：住宿用餐显温情

首日傍晚 17 点 30 分，梅花洲团建活动圆满结束，我们乘坐大巴前往当地四钻酒店 —— 嘉
兴南湖豪仕登大酒店。抵达酒店时，夕阳正缓缓落下，金色的余晖洒在酒店米白色的外墙上，显得 格外温馨大气。酒店门口，工作人员早已做好准备，微笑着迎接我们的到来。在行政部同事的提前 协调下，办理入住的流程格外顺畅。大家按照事先分好的房号，有序地在前台排队，有的同事主动 帮身边携带行李较多的伙伴拎包，有的则耐心地协助同事核对信息。前台工作人员动作麻利，很快 便为大家办理好了入住手续，并贴心地提醒大家晚餐的时间和地点。拿到房卡后，同事们三五成群 地走向电梯，一路上分享着白天团建的趣事，走廊里回荡着欢快的笑声。进入房间后，整洁舒适的 环境让人眼前一亮，柔软的大床、干净的洗漱间、窗边摆放的绿植，还有贴心准备的矿泉水和欢迎 卡片，细节之处尽显酒店的用心，让大家在忙碌一天后彻底放松下来。稍作休整后，大家按照约定 时间前往酒店餐厅用餐，餐厅内灯光柔和，桌椅摆放整齐，餐桌上早已摆满了精致的菜肴，清蒸鲈 鱼、东坡肉、嘉兴酱鸭等当地特色美食香气扑鼻，让人垂涎欲滴。大家围坐在一起，一边品尝美味 佳肴，一边畅谈白天的团建经历，彼此间的距离在温馨的用餐氛围中进一步拉近。
次日中午 12 点，游览完南湖后，我们前往南湖御品餐厅享用中餐。餐厅紧邻南湖，装修风格
极具江南特色，大厅内悬挂着水墨风格的画作，墙壁上点缀着精致的木雕饰品，营造出典雅舒适的 用餐环境。大家有序进入餐厅，按照事先安排好的桌次就座，服务员迅速上前为大家倒上茶水。不 一会儿，一道道精心烹制的菜肴陆续上桌，鲜嫩的南湖菱角、清香的荷塘月色、酥脆的炸春卷，每 一道菜都充满了江南的风味。用餐过程中，大家相互谦让，主动为身边的同事夹菜，有的同事还热 情地介绍着每道菜的特色，分享自己知道的嘉兴饮食文化。轻松愉快的用餐氛围中，不仅填饱了肚 子，更温暖了大家的心房，让同事情谊在不知不觉中愈发深厚。
`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-8.png")},

                {type:'text',center:`三、活力瞬间： 团建活动展风采

首日下午 13 点 30 分，期待已久的梅花洲团建活动正式拉开帷幕。梅花洲景区内绿树成荫，
流水潺潺，古朴的石桥与青砖黛瓦相映成趣，为此次团建活动提供了绝佳的场地。在专业教练的带  领下，大家首先在开阔的草坪上集合，开启 “破冰起航 ” 环节。教练通过 “名字接龙 ”“反向指 令 ” 等趣味互动游戏，迅速打破了大家之间的隔阂，原本略显拘谨的氛围瞬间变得活跃起来。随
后，教练采用随机报数的方式，将所有人平均分成 4 个小组，每组 10-12 人，且确保每组男女比  例均等，保证团队协作的平衡性。
紧接着是 “建立团队文化 ” 环节，各小组迅速找到属于自己的区域，围坐在一起讨论。按照
“自愿原则、具备赢的信念、基层岗位优先 ” 三大原则，各小组开始推选队长。当选队长后，他们 立刻组织大家讨论队名和团队口号，“斧头帮 ”“领航队 ”“汽车人队 ”“胜利队 ”充满力量的队  名相继诞生。为了让团队文化更具特色，大家还一起设计了队徽和展示动作，有的小组以握拳加油  为动作，有的小组则设计了整齐的队列变换。在团队文化展示环节，各小组依次登场，队长带领组  员们大声喊出团队口号，做出特色展示动作，“领航出击，无人能及！ ”“ 同心协力，争创佳
绩！ ” 响亮的口号在梅花洲的上空回荡，整齐有力的动作展现出每个团队的精神风貌，现场气氛瞬 间被点燃，每个人的脸上都写满了昂扬的斗志。
`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-9.png")},

                {type:'text',center:`
“团队齐心鼓 ” 项目是对团队协作能力的首次考验。每个小组面前都摆放着一个鼓，鼓面周围
均匀分布着绳索，每位队员手持一根绳索。当球被轻轻放在鼓面上，比赛正式开始。“一、二，
一、二 …… ” 在队长的统一指挥下，大家齐心协力控制鼓面起伏，试图让球在鼓面上持续跳跃。队 员们专注地盯着球，随着鼓点的节奏轻轻晃动绳索。渐渐地，鼓点越来越有规律，球颠起的次数也  越来越多。他们配合默契，球在鼓面上仿佛有了生命，一次次高高跃起，又稳稳落下。
`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-11.png")},
                {type:'text',center:`随后的 “妙笔生花 ” 项目更是充满挑战与乐趣。在直径 1 米的圈外，各小组队员手持绳索共
同控制一支大毛笔，需要在地面上书写团队的口号。这不仅需要每个人精准控制力度与方向，更需  要团队成员之间的高度默契，稍有偏差便会影响整体效果。“往左一点，慢些，再稳一点…… ”队  员们轻声交流，每个人都屏住呼吸，专注地盯着毛笔尖。根据毛笔的走向不断调整指令，其他队员  则严格按照指令调整力度。经过几分钟的努力，“ 同心致远，逐梦领航 ” 八个苍劲有力的大字呈现 在地面上，大家纷纷围上前，惊叹于团队的力量，也深刻体会到合理分工、恪尽职守的重要性`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-12.png")},
                {type:'text',center:`“齐心协力（巨人脚步） ” 项目则将团建活动推向了高潮。每个小组的队员们的脚用绑带固定
在一起，后面的队员扶着前面队员的肩膀。比赛要求各小组从起点出发，在规定时间内到达终点。
随着教练一声令下，各小组纷纷出发。起初，几乎所有小组都磕磕绊绊，但大家没有放弃，总结经  验。队员们齐声喊着 “一二一 ” 的口号，步伐逐渐变得一致。他们相互加油着，一步一步稳步前  进，最终到达终点。当冲过终点线的那一刻，队员们激动地欢呼起来，汗水与笑容交织在一起，成  为了梅花洲景区内最亮丽的风景线。
`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-14.png")},
                {type:'text',center:`“合力搭建 ”是一项极富趣味性和挑战性的团队协作活动，它模拟了一个团队的诞生、成长与
达成目标的完整过程。参与者需要通过有效的沟通、精密的策划与无缝的协作，共同将零散的组件 构筑成一座高耸的“梦想之塔 ”。
`}, 
                {type:'text',center:`“每个小组将利用指定的道具（积木、绳索与钩子），在有限的时间内，不直接用手接触建筑材
料的情况下，通过团队控制的吊装工具，从“地基 ”开始，一层一层地向上搭建一座高塔。整个过 程不仅是对团队战略规划、分工执行和风险管控能力的考验，更是对团队成员间耐心、细心和默契 度的终极挑战。`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-15.png")},
                {type:'text',center:`四、 团建意义 ：凝心聚力促发展

此次嘉兴南湖、梅花洲团建二日游，不仅让大家在忙碌的工作之余领略了江南水乡的秀丽风
光，更在一系列活动中收获了成长与感动，其意义深远且深刻。

从团队建设层面来看，此次团建活动有效增强了团队的凝聚力与向心力。在 “ 团队齐心鼓 ”
“妙笔生花 ”“ 巨人脚步 ” 等项目中，大家深刻体会到 “独木难成林，单弦难成曲 ” 的道理。当 面对困难时，没有一个人选择退缩，而是主动沟通、相互配合，共同寻找解决问题的方法。这种协  作精神不仅在团建活动中发挥了重要作用，更将成为未来工作中的宝贵财富。通过此次活动，部门  之间的壁垒被打破，同事之间的关系更加融洽，大家从 “工作伙伴 ” 变成了 “并肩作战的战
友 ”，整个团队的向心力得到了显著提升。

从个人成长角度而言，每位员工都在活动中突破了自我，收获了成长。在推选队长环节，年轻
同事主动承担责任，展现出强烈的担当精神；在面对 “妙笔生花 ”“ 巨人脚步 ” 等具有挑战性的  项目时，大家克服内心的胆怯，勇敢尝试，最终实现了自我突破。同时，在与同事的协作过程中，  大家学会了换位思考，理解了 “倾听 ” 与 “包容 ” 的重要性，个人的沟通能力与协作能力也得  到了锻炼与提升。
从文化传承与精神引领方面来讲，南湖红船的参观让大家接受了一次深刻的红色文化洗礼。通
过聆听革命历史，大家更加深刻地理解了 “红船精神 ” 的内涵 —— 开天辟地、敢为人先的首创  精神，坚定理想、百折不挠的奋斗精神，立党为公、忠诚为民的奉献精神。这种精神将激励着大家在未来的工作中， 以更加饱满的热情、更加坚定的信念面对挑战，勇于创新、敢于拼搏，为公司的
发展贡献自己的力量。

此次团建活动虽已结束，但它所带来的积极影响将持续发酵。未来，相信大家会将此次团建中
收获的勇气、默契与信念融入到日常工作中， 以更加团结的姿态、更加昂扬的斗志，共同面对工作 中的困难与挑战，携手为公司的发展添砖加瓦，书写属于我们团队的精彩篇章！

`}, 
                {type:'img',center:require("@/assets/img/News/newsImg12-16.png")},
                {type:'img',center:require("@/assets/img/News/newsImg12-17.png")},
            ]

        },


        {   
            id:13,
            url: require("@/assets/img/News/newsImg13.png"),
            title:'企业负责人获2025年度湖北潜江市五一劳动模范',
            abstract: ` 热烈祝贺东方久乐汽车电子（上海）股份有限公司的董事长兼总经理高劲松于近日获得2025年度湖北潜江市五一劳动模范奖章。`,
            release_time: '2025-09-28',
            subtitle: '----潜江分公司行政部  供稿',
            main_body_data:[
                {type:'text',center:`首先热烈祝贺东方久乐汽车电子（上海）股份有限公司的董事长兼总经理高劲松于近日获得2025年度湖北潜江市五一劳动模范奖章。
   高劲松辛勤耕耘20载，带领企业在国产汽车电子控制器领域占有一席之地，企业通过自主研发汽车安全电子控制系统，智能驾驶辅助系统等核心产品，成功打破国外技术垄断，为一汽、吉利、长城等80余家知名车企提供国产化配套支持，企业产值已突破10亿元。
虽然常年在上海打拼，但是高劲松始终心系家乡湖北潜江，始终不忘家乡潜江的培育之恩，希望有朝一日能够反哺家乡，于是他毅然在湖北潜江运粮湖管理区投资建设东久电子华中生产基地，2022年就实现产值4.1亿元，纳税超千万元，带动当地就业200余人，2023年，他再次推动二期50亩建设用地摘牌，项目建成后，潜江基地将承担集团80%产能，年产值预计突破20亿元，成为华中地区最具影响力的汽车电子产业基地。`},
                {type:'img',center:require("@/assets/img/News/newsImg13.png")},
                {type:'text',center:`从技术突围产业先锋，到反哺桑梓的实业楷模，高劲松以创新为笔，情怀为墨，书写了新时代企业家“科技报国，造福家乡”的动人篇章。这份赤子之心，还将激励更多人投身家乡建设，共绘乡村振兴的壮美画卷。`},
                {type:'img',center:require("@/assets/img/News/newsImg13-1.png")},
            ]

        },

        {   
            id:14,
            linktype: true,
            url: require("@/assets/img/News/newsImg14.png"),
            title:'东久安全带项目投产，运粮湖管理区又添发展新引擎',
            abstract: ` 9月26日，湖北东久汽车安全系统有限责任公司年产1200万条安全带项目投产仪式在运粮湖管理区举行。潜江市市委副书记、市长杨勇出席并宣布项目正式投产。`,
            release_time: '2025-06-26 17:13 发表于湖北',
            source: '运粮河畔',
            iframe_url: 'https://mp.weixin.qq.com/s/4zflEHH-wZzrO1Sh8gC2eQ',
        },

        {   
            id:15,
            url: require("@/assets/img/News/newsImg15.png"),
            title:'喜报！东久电子专家工作站正式获批 开启产学研协同创新新篇章​',
            abstract: ` 近日，东久电子传来重磅喜讯，经相关主管部门严格评审与认定，东久电子专家工作站正式获批设立。这一成果不仅是对公司科研实力与创新潜力的权威认可，更是企业搭建高层次产学研合作平台、加速核心技术攻关与成果转化的重要里程碑，标志着公司在技术创新与人才引育领域迈出了关键一步。`,
            release_time: '2025-12-09',
            subtitle: '----上海行政部  供稿',
             main_body_data:[
                {type:'text',center:`近日，东久电子传来重磅喜讯，经相关主管部门严格评审与认定，东久电子专家工作站正式获批设立。这一成果不仅是对公司科研实力与创新潜力的权威认可，更是企业搭建高层次产学研合作平台、加速核心技术攻关与成果转化的重要里程碑，标志着公司在技术创新与人才引育领域迈出了关键一步。`},
                {type:'text',center:`此次获批的专家工作站，是东久电子立足自身产业布局，联合上海交大专家团队共同搭建的创新载体。工作站以 “聚焦产业痛点、突破技术壁垒、赋能高质量发展” 为核心目标，精准对接行业前沿技术需求与企业实际研发难题，构建起 “企业主导、专家领衔、产学研联动” 的创新协作模式。 `},
                {type:'text',center:`据了解，工作站首批引进了以“机械结构振动与噪声控制技术” 领域知名专家谌勇教授为首的核心研发团队，该团队在“传感器抗干扰设计”、“电磁探测与成像”、“微弱磁场、电场测量” 等方向拥有深厚的技术积淀与丰富的产业化经验。双方将围绕公司核心业务板块的关键技术课题开展联合攻关，重点覆盖 IMS和BBS产品性能优化/工艺升级，突破国外技术垄断，同时兼顾人才培养与技术成果转化，形成 “研发 - 转化 - 应用” 的闭环创新体系。 `},
                {type:'text',center:`为保障工作站高效运转，公司已为专家团队配备了独立的研发办公区域、先进的实验检测设备，并设立专项研发基金，从硬件设施到资金支持提供全方位保障。此外，公司还建立了常态化沟通机制，定期组织技术研讨会与项目推进会，确保专家团队深度参与到企业研发全流程，实现智力资源与产业需求的精准匹配。`},
                {type:'text',center:`站在新的起点，东久电子将以专家工作站为核心枢纽，持续深化产学研合作，不断完善创新机制、加大研发投入，推动工作站成为技术创新的 “试验田”、成果转化的 “加速器”、人才培养的 “练兵场”。`},
                {type:'text',center:`此次专家工作站的获批，是东久电子创新发展道路上的重要契机。相信在高端智力资源的加持下，公司将进一步夯实技术优势、拓宽发展边界，为汽车电子行业高质量发展书写新的篇章。`},
                {type:'img',center:require("@/assets/img/News/newsImg15.png")},
            ]
        },





    ]
})



Mock.mock("/index.php/news-ind-list","get",{
    code: 0,//错误码
    msg: "",//错误消息
    //data为具体的消息内容，如果code不为0，则必为null
    data: [
        {   
            id:1,
            url: require("@/assets/img/News/newsIndImg1.png"),
            title:'中国一汽成立70周年特别报道│中国汽车工业暨一汽迎来70周年华诞',
            abstract: ` 7月15日，中国汽车工业迎来70周年华诞，“共和国长子”中国一汽也迎来成立70周年纪念日，一汽在吉林省长春市举办大会纪念这一时刻。当日，一汽生产的第5577万辆汽车在长春下线...`,
            release_time: '2023-07-15 21:35 发表于北京',
            source: '新华网汽车',
            iframe_url: 'https://mp.weixin.qq.com/s/uJ8wCHhHoJWeT7MQu21FPA',
        },

        {   
            id:2,
            url: require("@/assets/img/News/newsIndImg2.png"),
            title:'15.98万起售，比预售便宜1万，2023款比亚迪宋PLUS DM-i冠军版上市',
            abstract: ` 要问当下汽车市场销量最好的品牌是哪家？答案一定是比亚迪，再问比亚迪卖的最好的车是哪一款？宋PLUS绝对是其中之一。根据比亚迪最新销量数据，宋PLUS系列车型6月销量达到25935辆，上半年累计销量达到18.42万辆，不仅成为比亚迪海洋网的一大热门车型，更是支撑比亚迪上半年销量突破124.8万辆，继续稳坐乘用车冠军宝座...`,
            release_time: '2023-07-17 18:56 发表于江西',
            source: '米邦车讯',
            iframe_url: 'https://mp.weixin.qq.com/s/6C8vN6kKO1MmsKbkpprKdg',
        },

        {   
            id:3,
            url: require("@/assets/img/News/newsIndImg3.png"),
            title:'2023年9月份乘用车销量',
            abstract: ` 2023年9月乘用车市场零售达到201.8万辆，同比增长5.0%，环比增长5.0%。今年以来累计零售1523.3万辆，同比增长2.4%。...`,
            release_time: '2023-10-11 20:20 发表于广东',
            source: '一览众车',
            iframe_url: 'https://mp.weixin.qq.com/s/RYlxpJyJRYPjuvD_zZwz8g',
        },

        {   
            id:4,
            url: require("@/assets/img/News/newsIndImg4.png"),
            title:'企业生产忙 力争“开门红”',
            abstract: ` 1月2日，在河北省石家庄新乐市东方久乐汽车电子（上海）股份有限公司新乐分公司生产车间，工人在生产线加紧生产出口订单。新年伊始，各地企业开足马力赶订单、忙生产，力争“开门红”。`,
            release_time: '2025-01-03 16:37发表于新华网',
            source: '新华网',
            iframe_url: 'https://www.news.cn/photo/20250103/346a2a8180f1496db0333e55b50b455d/c.html?page=14&sid_for_share=99125_3',
        },


        {   
            id:5,
            url: require("@/assets/img/News/newsIndImg5.png"),
            title:'李明政调研重点工业企业节后复工复产情况”',
            abstract: ` 2月5日，市委书记李明政到部分重点工业企业调研了复工复产情况。李明政先后到久乐气囊、久乐电子、利华药业、博宇氨基酸、奥星药业等工业企业进行实地调研。每到一处，李明政都与企业负责人亲切交谈，认真听取他们对企业复工复产情况的介绍，详细了解企业生产经营、销售市场及新一年发展方向等情况。`,
            release_time: '2025年02月05日 18:03 河北 新乐市发布',
            source: '新乐市发布',
            iframe_url: 'https://mp.weixin.qq.com/s/Vvizl-15tu3-udMbOC41FA',
        },

        {   
            id:6,
            url: require("@/assets/img/News/newsIndImg6.png"),
            title:'2024-2030年汽车低压锂电池市场及企业调研报告”',
            abstract: `相对铅酸电池，锂电池能量密度更大，循环寿命更长，同时金属锂对环境的污染相对较小。在汽车低压电池领域，锂电的应用也越来越广泛，虽然从实际情况来看，锂电对铅酸的进展相对缓慢，但趋势已显，未来仍有较大的市场空间。`,
            release_time: '原创 一览众咨询 一览众车2025年03月11日 10:22 广东',
            source: '一览众车',
            iframe_url: 'https://mp.weixin.qq.com/s/WGL0tQOFHydNXWL47LEpNA',
        },


        {   
            id:7,
            url: require("@/assets/img/News/newsIndImg7.png"),
            title:'2024-2030年新能源汽车热管理市场及企业调研报告”',
            abstract: `新能源汽车的发展，对于汽车热管理系统是一场大的变革。传统燃油车的热管理架构主要包括了空调系统以及动力总成热管理系统。新能源汽车由于动力源发生了变化，新增了三电系统，因此要对电池、电机、电控等进行热管理的重新构建。`,
            release_time: ' 一览众咨询 一览众车 2025年03月10日 21:43 广东',
            source: '一览众车',
            iframe_url: 'https://mp.weixin.qq.com/s/89sAa-FAMJTCL85Z5zz-vw',
        },


        {   
            id:8,
            url: require("@/assets/img/News/newsIndImg8.png"),
            title:'从“百舸争流”到“七雄争霸”，中国汽车业大整合催生全球竞争新秩序”',
            abstract: `3月29日，国务院国资委相关负责人在中国电动汽车百人会论坛上表示，下一步将对整车央企进行战略性重组，提高产业集中度。战略性重组的目标是集中央企的研发制造和市场等优势资源，打造具有全球竞争力、拥有自主核心技术，引领智能网联变革的世界一流汽车集团。此外，还将鼓励央企加大其他合作`,
            release_time: ' 新华汽车网 2025年03月31日 13:00 北京',
            source: '新华汽车网',
            iframe_url: 'https://mp.weixin.qq.com/s/LqT8F01d9KXoBJkAqYBb_g',
        },

    ]
})